/**
 * @engine/vfx — GPU-accelerated visual effects.
 *
 * A node-graph authoring model (`graph/`) compiled function-per-node to Slang
 * (→ WGSL via the injected compile service), plus a runtime that
 * plays back compiled effects (`runtime/`). The legacy CPU `VFXSystem`/`Particle`
 * stack was removed — the graph system fully supersedes it.
 *
 * NOTE: this barrel is intentionally broad for now; Phase C narrows it to an
 * explicit runtime-vs-editor surface.
 *
 * @module @engine/vfx
 */

// VFX Runtime (emitter management, texture loaders, compiled-bundle types).
export * from './runtime';

// VFX Graph system (GPU): authoring model, node registry, compiler, presets,
// content pipeline, renderers.
export * from './graph';
